// The input owns decimal text; the API/stored property owns numeric dollars.
const COMPLETE = /^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/;
const CAN_EDIT = /^\d*(?:\.\d{0,2})?$/;
export const DELIVERY_COMMISSION_ERROR = 'Enter a nonnegative amount using digits and up to two decimal places.';

const canonicalText = text => {
  const [whole, fraction = ''] = text.split('.');
  return `${Number(whole)}.${fraction.padEnd(2, '0')}`;
};

export const isDeliveryCommissionEntry = value => typeof value === 'string' && CAN_EDIT.test(value);

export const isDeliveryCommission = value => typeof value === 'number' && Number.isFinite(value)
  && value >= 0 && COMPLETE.test(String(value)) && Number.isSafeInteger(Math.round(value * 100))
  && value.toFixed(2) === canonicalText(String(value));

export function parseDeliveryCommission(text) {
  if (text === '') return null; // A clear command; never a stored null rate.
  if (typeof text !== 'string' || !COMPLETE.test(text)) throw new Error(DELIVERY_COMMISSION_ERROR);
  const value = Number(text);
  if (!isDeliveryCommission(value)
    || value.toFixed(2) !== canonicalText(text)) throw new Error(DELIVERY_COMMISSION_ERROR);
  return value;
}

export const deliveryCommissionDraft = source => typeof source?.deliveryCommission === 'string'
  ? source.deliveryCommission : isDeliveryCommission(source?.deliveryCommission)
    ? source.deliveryCommission.toFixed(2) : '';
